import { openTab } from '../state/tabs.ts';

// Koppelingen uit mail (/?open=briefing&id=…): openen het juiste tabblad en overleven het inloggen
// (de omweg via Microsoft verliest de parameters; daarom bewaren we ze even in sessionStorage).

export const DEEP_LINK_KEY = 'jerome2.deeplink';

export function rememberDeepLink(search: string = location.search): void {
  try {
    if (/[?&]open=/.test(search)) sessionStorage.setItem(DEEP_LINK_KEY, search);
  } catch {
    // geen opslag beschikbaar
  }
}

/** De koppeling die vóór het inloggen is bewaard, eenmalig. */
export function takeStoredDeepLink(): string {
  try {
    const s = sessionStorage.getItem(DEEP_LINK_KEY) ?? '';
    if (s) sessionStorage.removeItem(DEEP_LINK_KEY);
    return s;
  } catch {
    return '';
  }
}

/** Opent het tabblad uit de koppeling; de parameters gaan daarna uit de adresbalk. */
export function openDeepLink(search: string, opts: { clean?: boolean } = {}): boolean {
  const q = new URLSearchParams(search);
  const open = q.get('open');
  if (!open) return false;
  const id = q.get('id');
  if (open === 'briefing') openTab('briefing', { single: true, state: { briefingId: id ?? undefined } });
  else if (open === 'releases') openTab('releases', { single: true });
  // De link in een melding over WhatsApp (sinds 2.3.1): het tabblad WhatsApp met de uitleg en de knop naar Instellingen.
  else if (open === 'whatsapp') openTab('whatsapp', { single: true });
  else if (open === 'mail') openTab('mail', { single: true, ...(id ? { state: { selectedId: id, view: 'processed', processed: 'all' } } : {}) });
  else return false;
  if (opts.clean !== false && typeof history !== 'undefined' && location.search) history.replaceState(null, '', location.pathname);
  return true;
}
